import React from 'react';
import QRCode from '../assets/qrCode.svg';
import Iara from 'images/homepage/support/iara.png';

import { IaraSectionContainer, IaraImage, ContentContainer, Title, Description, Button, QRCodeImage } from './IaraSection.styled';

const IaraSection = () => {
    const handleAccess = () => {
        window.open('https://wa.me/5511989512418', '_blank');
    };

    return (
        <IaraSectionContainer>
            <IaraImage src={Iara} alt="IAra" />

            <ContentContainer>
                <Title>Chegou a Iara, o novo canal de atendimento do Instituto!</Title>

                <Description>
                    A IAra reúne informações sobre programas, procedimentos, cursos e mais. Ela tira suas dúvidas com mais agilidade, praticidade
                    e autonomia, através de uma conversa pelo WhatsApp.
                </Description>

                <Button onClick={handleAccess}>Fale com a IAra</Button>
            </ContentContainer>

            <QRCodeImage src={QRCode} alt="QR Code para falar com a IAra pelo WhatsApp" />
        </IaraSectionContainer>
    );
};

export default IaraSection;
